import { useEffect, useState } from "react";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
import { useUrlFilterState } from "../../hooks/useUrlFilterState";
import { useBulkOrderMode } from "../../hooks/useAuthorisation";
// State Import
import { useOrderList } from "../../state/orderListStateV2";
// Component imports
import { OrderListHeader } from "./OrderListHeader";
import { OrderTable } from "./OrderTable";
import { OrderFilterBar } from "./OrderFilterBar";
// MUI
import Typography from "@mui/material/Typography";

export function OrderList({ status }) {
  const bulkOrderMode = useBulkOrderMode();
  // Single source of truth for merging, so the table never shows checkboxes
  // without the header offering the action that consumes them.
  const canMerge = status === "draft" && !bulkOrderMode;

  // Data Grid Columns
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    // createdName: false,
    approvalBy: false,
  });

  let isTypeApproval = false;
  if (status === "approved-orders" || status === "approved-invoices") {
    isTypeApproval = true;
  }

  // // Set the list variable name
  // let listName = "order";
  // if (status !== "draft") {
  //   listName = "invoice";
  // }

  const [orderFilter, setOrderFilter] = useUrlFilterState(
    {
      type: status,
      search: "",
      orderFilter: isTypeApproval ? "MyApprovals" : "Mine",
      myBranchesFilter: "All",
      page: 1,
      pageSize: 25,
      showApprovals: "All",
    },
    { exclude: ["type", "pageSize"] },
  );

  const [orderList, setOrderList] = useState({
    filter: {},
    paging: {},
    order: [],
    draft: [],
    invoice: [],
  });

  // Fetch Order List
  const { isPending, isError, data, error, isFetching, isSuccess } =
    useOrderList(orderFilter);
  // Success Function
  const successFunc = () => {
    setOrderList(data.data.data.data.list);
  };
  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);
  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  // State to hold order rows selected by the user
  const [selectedRows, setSelectedRows] = useState([]);

  // Selections persist across pages by design, but a change of filter swaps the
  // result set for a different one, so anything still selected is now hidden.
  const selectionScopeKey = JSON.stringify([
    orderFilter.type,
    orderFilter.search,
    orderFilter.orderFilter,
    orderFilter.myBranchesFilter,
    orderFilter.showApprovals,
  ]);
  useEffect(() => {
    setSelectedRows([]);
  }, [selectionScopeKey]);

  return (
    <>
      <OrderListHeader
        status={status}
        canMerge={canMerge}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
      />
      <OrderFilterBar
        status={status}
        orderFilter={orderFilter}
        setOrderFilter={setOrderFilter}
        setColumnVisibilityModel={setColumnVisibilityModel}
        isTypeApproval={isTypeApproval}
      />
      {isError && <Typography>Error: {error.message}</Typography>}
      <OrderTable
        status={status}
        data={orderList}
        loading={isFetching}
        orderFilter={orderFilter}
        setOrderFilter={setOrderFilter}
        columnVisibilityModel={columnVisibilityModel}
        canMerge={canMerge}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
      />
    </>
  );
}
